if($('.hero-carousel').length) {

    $('.hero-carousel').each(function () {

        let slider = $(this).find('.hero-carousel-slider'),
            prevArrow = '<button type="button" class="slick-prev"><img src="/assets/img/controls/prev-slide-arrow.svg" alt="Previous Project"></button>',
            nextArrow = '<button type="button" class="slick-next"><img src="/assets/img/controls/next-slide-arrow.svg" alt="Next Project"></button>';

        if($(this).data('auto-cycle-speed')) {

            let autoCycleSpeed = $(this).data('auto-cycle-speed');

            slider.slick({
                autoplay: true,
                autoplaySpeed: parseInt(autoCycleSpeed),
                fade: true,
                prevArrow: prevArrow,
                nextArrow: nextArrow
            });

        } else {

            slider.slick({
                fade: true,
                prevArrow: prevArrow,
                nextArrow: nextArrow
            });

        }

    });

}
